// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NX5Z","type":"styles_type__2pE4F","choices":"styles_choices__2D4MH"};